import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const getFinalStateMachine = prop('xstate');
export const getWorkflowState = createSelector(getFinalStateMachine, prop('value'));
export const getHistoryState = createSelector(getFinalStateMachine, prop('history'));
export const getPreviousPage = createSelector(getHistoryState, prop('value'));
